export default {
  files: {
    addAttachment: 103127, // Add Attachment
    adjustYourImageToFit: 101909, // Adjust your image to fit!
    attachment: 103126, // Attachment
    fileSReadyForUpload: 103130, // {0} file(s) ready for upload
    removeImage: 101911, // Remove Image
    replaceImage: 101910, // Replace Image
    somethingWentWrongWhenUploadingYourFilePleaseTryAgain: 101912, // Something went wrong when uploading your file. Please try again.
    unsavedChanges: 103131, // Unsaved Changes
    uploadImage: 101908, // Upload Image
    uploadProfilePicture: 101999, // Upload Profile Picture
    uploadUpToMaxfilesFile: 103129, // Upload up to {0} file(s)
    youHaveUnsavedChangesWouldYouLikeToSave: 103132, // You have unsaved changes. Would you like to save them?
    yourFileSizeOfLimitMbExceedsTheSizeLimit: 101914, // Your file size of {limit} mb exceeds the size limit of {size} mb.'
    yourFileTypeIsNotAllowed: 101913, // Your file type is not allowed.
    yourProfilePictureWasRemovedSuccessfully: 101998, // Your profile picture was removed successfully!
    yourProfilePictureWasUpdatedSuccessfully: 101997, // Your profile picture was updated successfully!
  }
}
